import { render, staticRenderFns } from "./EditCenterDialog.vue?vue&type=template&id=34461e52&"
import script from "./EditCenterDialog.vue?vue&type=script&lang=ts&"
export * from "./EditCenterDialog.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports